import { styled } from "@mui/material/styles";
import { Box, Button, Checkbox, Typography } from "@mui/material";
import Colors from "src/general/constants/colors";
import BreakPoints from "src/general/constants/breakPoints";

interface TicTacProps {
	selected: boolean;
}

interface LeftRightButtonProps {
	isActiveList?: boolean;
}

interface LessonProps {
	selectLesson: boolean;
}
interface LessonPrivateProps {
	selectLesson: boolean;
}

interface GreenIconProps {
	activeLesson: boolean;
}

interface GreenIconPrivateProps {
	activeLesson: boolean;
}

interface AttestationProps {
	attestationCompleted: boolean;
}

export const MaterialEventContainer = styled("div")(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	gap: "24px",
	padding: "0px",
	margin: "0px",
	width: "100%",

	[`@media  (min-width: ${BreakPoints.TABLET_1023}px) and ( max-width: ${BreakPoints.LARGE_1439}px)`]:
		{
			gap: "16px",
		},
}));

export const MaterialLinks = styled("div")(({ theme }) => ({
	display: "flex",
	justifyContent: "space-between",
	padding: "12px",
	borderRadius: "16px",
	gap: "16px",
	backgroundColor: Colors.WHITE,
	boxShadow: "0px 4px 16px 0px #7474741F",

	[`@media  (min-width: ${BreakPoints.TABLET_1023}px) and ( max-width: ${BreakPoints.LARGE_1439}px)`]:
		{
			gap: "8px",
			padding: "8px",
		},

	[`@media  (min-width: ${BreakPoints.TAPOK_319}px) and ( max-width: ${BreakPoints.TABLET_1023}px)`]:
		{
			flexWrap: "wrap",
			gap: "8px",
		},
}));

export const StyledA = styled("a")(({ theme }) => ({
	display: "flex",

	textDecoration: "none",
	color: "inherit",

	[`@media  (min-width: ${BreakPoints.PC_1279}px) `]: {
		flex: 1,
	},
	[`@media  (min-width: ${BreakPoints.TAPOK_319}px) and ( max-width: ${BreakPoints.TABLET_1023}px)`]:
		{
			flex: 1,
		},
}));

export const StyledTypography = styled(Typography)(({ theme }) => ({
	color: Colors.BLACK_OLD,
}));

export const TicTac = styled("div")(({ theme }) => ({
	display: "flex",
	alignItems: "center",
	justifyContent: "center",
	borderRadius: "16px",
	padding: "8px 16px",
	gap: "8px",
	backgroundColor: Colors.GREY_F6,
	width: "100%",
	whiteSpace: "nowrap",

	[`@media  (min-width: ${BreakPoints.TABLET_1023}px) and ( max-width: ${BreakPoints.PC_1279}px)`]:
		{
			padding: "6px 6px",
			gap: "4px",
		},
}));

export const VideoAndInfoContainer = styled("div")(({ theme }) => ({
	display: "flex",
	flexDirection: "row",
	gap: "24px",

	[`@media  (min-width: ${BreakPoints.LARGE_1439}px) and ( max-width: ${BreakPoints.FHD_1919}px)`]:
		{
			gap: "16px",
		},
	[`@media  (min-width: ${BreakPoints.TABLET_1023}px) and ( max-width: ${BreakPoints.LARGE_1439}px)`]:
		{
			gap: "10px",
		},
	[`@media  (min-width: ${BreakPoints.TAPOK_319}px) and ( max-width: ${BreakPoints.TABLET_1023}px)`]:
		{
			flexDirection: "column",
		},
}));

export const VideoContainer = styled("div")(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	gap: "24px",
	borderRadius: "16px",
	width: "65%",

	[`@media  (min-width: ${BreakPoints.TABLET_1023}px) and ( max-width: ${BreakPoints.LARGE_1439}px)`]:
		{
			gap: "16px",
		},
	[`@media  (min-width: ${BreakPoints.TAPOK_319}px) and ( max-width: ${BreakPoints.TABLET_1023}px)`]:
		{
			width: "100%",
		},
}));

export const VideoModule = styled("section")(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	borderRadius: "16px",
	padding: "16px",
	gap: "16px",
	backgroundColor: Colors.WHITE,
	boxShadow: "0px 4px 16px 0px #7474741F",

	[`@media  (min-width: ${BreakPoints.TABLET_1023}px) and ( max-width: ${BreakPoints.LARGE_1439}px)`]:
		{
			padding: "8px",
		},
}));

export const VideoWrapper = styled("div")(({ theme }) => ({
	position: "relative",
	width: "100%",
	paddingTop: "56.25%",
	overflow: "hidden",
	borderRadius: "16px",

	"& iframe": {
		position: "absolute",
		top: 0,
		left: 0,
		width: "100%",
		height: "100%",
	},
}));

export const RectangleIcon = styled(Box)(({ theme }) => ({
	width: "4px",
	height: "32px",
	borderRadius: "24px",
	backgroundColor: Colors.GREEN,
}));

export const Title = styled("div")(({ theme }) => ({
	display: "flex",
	flexDirection: "row",
	alignItems: "center",
	gap: "8px",
}));

export const DownloadPDF = styled("div")(({ theme }) => ({
	display: "flex",
	flexDirection: "row",
	justifyContent: "space-between",
	alignItems: "center",
	padding: "16px",
	borderRadius: "16px",
	border: `1px solid ${Colors.GREY}`,

	[`@media  (min-width: ${BreakPoints.TABLET_1023}px) and ( max-width: ${BreakPoints.LARGE_1439}px)`]:
		{
			padding: "8px",
		},
}));

export const GreenCheckbox = styled(Checkbox)(({ theme }) => ({
	color: Colors.GREEN,
	width: "24px",
	height: "24px",
	"&.Mui-checked": {
		color: Colors.GREEN,
	},
}));

export const LeftRightButtons = styled("div")(({ theme }) => ({
	display: "flex",
	flexDirection: "row",
	justifyContent: "space-between",
}));

export const LeftRightButton = styled(Button, {
	shouldForwardProp: (prop) => prop !== "isActiveList",
})<LeftRightButtonProps>(({ theme, isActiveList }) => ({
	display: "flex",
	flexDirection: "row",
	alignItems: "center",
	borderRadius: "32px",
	cursor: "pointer",
	gap: "12px",
	color: isActiveList ? Colors.GREEN : Colors.GREY,
	border: `1px solid ${isActiveList ? Colors.GREEN : Colors.DARK_GREY3}`,

	[`@media  (min-width: ${BreakPoints.TABLET_1023}px) and ( max-width: ${BreakPoints.LARGE_1439}px)`]:
		{
			padding: "6px 12px",
		},
}));

///////////////////////////////////////////////////////////////////////////////////////
export const InfoContainer = styled("div")(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	gap: "24px",
	width: "35%",

	[`@media  (min-width: ${BreakPoints.TABLET_1023}px) and ( max-width: ${BreakPoints.LARGE_1439}px)`]:
		{
			width: "45%",
		},
	[`@media  (min-width: ${BreakPoints.TAPOK_319}px) and ( max-width: ${BreakPoints.TABLET_1023}px)`]:
		{
			width: "100%",
		},
}));

export const InfoModule = styled("div")(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	padding: "20px",
	gap: "24px",
	borderRadius: "16px",
	boxShadow: "0px 4px 16px 0px #7474741F",

	[`@media  (min-width: ${BreakPoints.TABLET_1023}px) and ( max-width: ${BreakPoints.LARGE_1439}px)`]:
		{
			padding: "16px",
		},
	[`@media  (min-width: ${BreakPoints.TAPOK_319}px) and ( max-width: ${BreakPoints.MOBILE_767}px)`]:
		{
			padding: "8px",
		},
}));

export const res320_768Del = styled("div")(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	gap: "24px",

	[`@media  (min-width: ${BreakPoints.TABLET_1023}px) and ( max-width: ${BreakPoints.LARGE_1439}px)`]:
		{
			gap: "16px",
		},
	[`@media  (min-width: ${BreakPoints.TAPOK_319}px) and ( max-width: ${BreakPoints.TABLET_1023}px)`]:
		{
			display: "none",
		},
}));
export const res320_768Add = styled("div")(({ theme }) => ({
	[`@media  (min-width: ${BreakPoints.TABLET_1023}px)`]: {
		display: "none",
	},
}));

export const InfoTitle = styled("div")(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	alignItems: "start",
	gap: "4px",
	whiteSpace: "nowrap",
}));

export const TitleContainer = styled("div")(({ theme }) => ({
	display: "flex",
	flexDirection: "row",
	alignItems: "center",
	justifyContent: "space-between",
	gap: "4px",
}));

export const Baydges = styled("div")(({ theme }) => ({
	display: "flex",
	flexDirection: "row",
	gap: "4px",
}));

export const Baydge = styled("div")(({ theme, color }) => ({
	display: "flex",
	justifyContent: "center",
	alignItems: "center",
	padding: "8px 16px",
	borderRadius: "32px",
	backgroundColor: color,

	[`@media  (min-width: ${BreakPoints.TABLET_1023}px) and ( max-width: ${BreakPoints.LARGE_1439}px)`]:
		{
			padding: "6px 12px",
		},
}));

export const NameModule = styled("div")(({ theme }) => ({
	display: "flex",
	textAlign: "left",
}));

export const LineStrix = styled("div")(() => ({
	position: "relative",
	"&::after": {
		content: '""',
		position: "absolute",
		left: 0,
		bottom: 0,
		width: "100%",
		height: "1px",
		background:
			"repeating-linear-gradient(to right, transparent, " +
			Colors.DARK_GREY3 +
			" 3px, transparent 10px, transparent 20px)",
	},
}));

export const ProgressBar = styled("div")(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
}));

export const TitleProgressBarContainer = styled("div")(({ theme }) => ({
	display: "flex",
	justifyContent: "space-between",
	width: "100%",
}));

export const TitleRowContainer = styled("div")(({ theme }) => ({
	display: "flex",
	flexDirection: "row",
	alignItems: "center",
}));

export const Lessons = styled("div")(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	gap: "16px",
}));

export const LessonsFilters = styled("div")(({ theme }) => ({
	display: "flex",
	justifyContent: "space-between",
	gap: "16px",

	[`@media  (min-width: ${BreakPoints.TAPOK_319}px) and ( max-width: ${BreakPoints.FHD_1919}px)`]:
		{
			gap: "8px",
		},
}));

export const TicTacFilter = styled("div")<TicTacProps>(
	({ theme, selected }) => ({
		display: "flex",
		justifyContent: "center",
		flex: 1,
		borderRadius: "16px",
		padding: "8px 16px",
		gap: "8px",
		backgroundColor: selected ? Colors.GREEN_LIGHT : Colors.GREY_F6,

		[`@media  (min-width: ${BreakPoints.TABLET_1023}px) and ( max-width: ${BreakPoints.FHD_1919}px)`]:
			{
				padding: "8px 8px",
			},
		[`@media  (min-width: ${BreakPoints.TAPOK_319}px) and ( max-width: ${BreakPoints.MOBILE_767}px)`]:
			{
				padding: "8px 8px",
			},
	})
);

export const LessonsList = styled("div")(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	gap: "16px",

	maxHeight: "650px",
	overflowY: "auto",

	"&::-webkit-scrollbar": {
		width: "6px",
	},

	"&::-webkit-scrollbar-thumb": {
		background: Colors.GREEN_LIGHT,
		borderRadius: "3px",
		display: "none",
	},
}));

export const Lesson = styled("div")<LessonProps>(({ theme, selectLesson }) => ({
	display: "flex",
	flexDirection: "row",
	justifyContent: "space-between",
	padding: "16px",
	borderRadius: "16px",
	border: `1px solid ${Colors.GREEN_LIGHT}`,
	backgroundColor: selectLesson ? Colors.GREEN_LIGHT : Colors.WHITE,
}));
export const LessonPrivate = styled("div")<LessonPrivateProps>(
	({ theme, selectLesson }) => ({
		display: "flex",
		flexDirection: "column",
		justifyContent: "space-between",
		alignItems: "start",
		padding: "16px",
		gap: "8px",
		borderRadius: "16px",
		border: `1px solid ${Colors.GREEN_LIGHT}`,
		backgroundColor: selectLesson ? Colors.GREEN_LIGHT : Colors.WHITE,
	})
);

export const GreenIcon = styled(Box)<GreenIconProps>(
	({ theme, activeLesson }) => ({
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		width: 24,
		height: 24,
		minWidth: 24,
		borderRadius: "50%",
		backgroundColor: activeLesson ? Colors.GREEN : Colors.DARK_GREY3,
		color: "white",
	})
);
export const GreenIconPrivate = styled(Box)<GreenIconPrivateProps>(
	({ theme, activeLesson }) => ({
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		width: 24,
		height: 24,
		minWidth: 24,
		borderRadius: "50%",
		backgroundColor: activeLesson
			? Colors.GREEN // если предыдущий урок пройден
			: Colors.DARK_GREY3,
		color: "white",
	})
);

export const LessonName = styled("div")(({ theme }) => ({
	display: "flex",
	justifyContent: "flex-start",
	alignItems: "center",
	gap: "8px",
	width: "90%",
}));
export const LessonPrivateName = styled("div")(({ theme }) => ({
	display: "flex",
	justifyContent: "space-between",
	alignItems: "center",
	gap: "8px",
	width: "100%",
}));
export const LessonNameTwo = styled("div")(({ theme }) => ({
	display: "flex",
	justifyContent: "flex-start",
	alignItems: "center",
	gap: "8px",
	width: "100%",
}));

export const LessonsListPrivate = styled("div")(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	padding: "20px",
	borderRadius: "16px",
	gap: "16px",
	backgroundColor: Colors.GREY_F6,
}));

export const AttestationButton = styled(Button)<AttestationProps>(
	({ theme, attestationCompleted }) => ({
		display: "flex",
		flexDirection: "row",
		justifyContent: "start",
		padding: "8px 22px",
		alignItems: "start",
		borderRadius: "32px",
		cursor: "pointer",
		gap: "12px",
		color: Colors.GREEN,
		border: `1px solid ${Colors.GREEN}`,
		width: "fit-content",
	})
);

export const AttestationTitleContainer = styled("div")(({ theme }) => ({
	display: "flex",
	flexDirection: "row",
	alignItems: "center",
	justifyContent: "space-between",
	gap: "4px",
}));
